"use strict";

var cov_tfw4kgjun = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\selections\\Selections.context.js";
  var hash = "6e963de9adc96869157ad669db9de48332c2e7de";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\selections\\Selections.context.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 33
        },
        end: {
          line: 6,
          column: 48
        }
      },
      "1": {
        start: {
          line: 18,
          column: 25
        },
        end: {
          line: 25,
          column: 4
        }
      },
      "2": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 31,
          column: 4
        }
      },
      "3": {
        start: {
          line: 34,
          column: 0
        },
        end: {
          line: 47,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "SelectionsContextProvider",
        decl: {
          start: {
            line: 8,
            column: 16
          },
          end: {
            line: 8,
            column: 41
          }
        },
        loc: {
          start: {
            line: 16,
            column: 3
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "6e963de9adc96869157ad669db9de48332c2e7de"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectionsContextProvider = SelectionsContextProvider;
exports.default = exports.SelectionsContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("..");

var SelectionsContext = (cov_tfw4kgjun.s[0]++, (0, _react.createContext)());
exports.SelectionsContext = SelectionsContext;

function SelectionsContextProvider(_ref) {
  var selections = _ref.selections,
      onSelections = _ref.onSelections,
      occurrence = _ref.occurrence,
      quote = _ref.quote,
      onQuote = _ref.onQuote,
      verseObjects = _ref.verseObjects,
      children = _ref.children;
  cov_tfw4kgjun.f[0]++;

  var _ref2 = (cov_tfw4kgjun.s[1]++, (0, _.useSelections)({
    selections: selections,
    onSelections: onSelections,
    occurrence: occurrence,
    quote: quote,
    onQuote: onQuote,
    verseObjects: verseObjects
  })),
      state = _ref2.state,
      actions = _ref2.actions;

  cov_tfw4kgjun.s[2]++;
  return _react.default.createElement(SelectionsContext.Provider, {
    value: {
      state: state,
      actions: actions
    }
  }, children);
}

;
cov_tfw4kgjun.s[3]++;
SelectionsContextProvider.propTypes = {
  /** words in a selection */
  selections: _propTypes.default.array,

  /** action taken after a selection is made */
  onSelections: _propTypes.default.func.isRequired,

  /** the quote to be selected */
  quote: _propTypes.default.string.isRequired,

  /** the verses where quote may be found */
  verseObjects: _propTypes.default.array,

  /** if quote occurs mulitple times, this is the occurence of the one selected */
  occurrence: _propTypes.default.number,

  /** action taken when quote is provided */
  onQuote: _propTypes.default.func
};
var _default = SelectionsContextProvider;
exports.default = _default;